export default __webpack_public_path__ + "static/char-s-04-jp-1388afb4d31a2201652e94e0857ca1f1.webp";